import { Resource } from '@ekuaibao/fetch';
var feeTypeRes = new Resource('/api/v1/form/feeTypes');
export function getFeeTypeByIds(ids) {
    return feeTypeRes.GET('/[ids]', { ids: ids });
}
